import { useMutation } from '@apollo/client'
import { FormattedMessage } from 'react-intl'
import { FormEvent, ReactElement } from 'react'

import { Button } from 'components/v2/Button'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import Heading from 'components/v2/Heading'
import Modal from 'components/v2/Modal'
import { CenteredText } from 'components/Text'
import { ARCHIVE_INVENTORY } from 'features/Inventories/mutations-legacy'
import { getUnprocessableErrors } from 'utils/error'
import { IArchiveInventoryModalProps } from './types'

export const ArchiveInventoryModal = ({ inventory, closeModal }: IArchiveInventoryModalProps): ReactElement => {
  const [archiveInventory, { loading, error }] = useMutation(ARCHIVE_INVENTORY, {
    onCompleted() {
      closeModal()
    },
    update(cache) {
      cache.evict({ id: cache.identify({ id: inventory.id, __typename: 'Inventory' }) })
      cache.gc()
    }
  })

  const handleSubmit = (event: FormEvent): void => {
    event.preventDefault()

    archiveInventory({
      variables: {
        input: {
          id: inventory.id
        }
      }
    })
  }

  return (
    <Modal.Container>
      <Modal.Header>
        <Heading.H5>
          <FormattedMessage id="spanish.inventories.list.actions.archive.title" defaultMessage="Archivar ubicación" />
        </Heading.H5>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Content>
          <CenteredText>
            <FormattedMessage
              id="spanish.inventories.list.actions.archive.confirmation"
              defaultMessage="¿Estas seguro que deseas archivar la ubicación {inventoryName}?"
              values={{
                inventoryName: inventory.name
              }}
            />
          </CenteredText>
        </Modal.Content>
        <Modal.Footer>
          {error && (
            <Modal.ErrorMessage>
              <ErrorMessage errors={getUnprocessableErrors(error)}>
                <FormattedMessage
                  id="spanish.inventories.list.actions.archive.error"
                  defaultMessage="Hubo un error al archivar la ubicación. Por favor, intenta nuevamente."
                />
              </ErrorMessage>
            </Modal.ErrorMessage>
          )}
          <Modal.Actions>
            <Button kind="cancel" onClick={(): void => closeModal()}>
              <FormattedMessage id="spanish.modal.actions.close" defaultMessage="No, cerrar" />
            </Button>
            <Button kind="primary" loading={loading}>
              <FormattedMessage id="spanish.inventories.list.actions.archive.submit" defaultMessage="Si, archivar" />
            </Button>
          </Modal.Actions>
        </Modal.Footer>
      </form>
    </Modal.Container>
  )
}
